const parser = new DOMParser();
const footer = document.querySelector("#footer");
const template = document.body.dataset.template;
const reviewsSelect = document.querySelector("#reviews-select");
const clearAll = document.querySelector("#clear-all");
const reviewsUl = document.querySelector("#reviews-ul");
const reviewsLi = document.querySelectorAll("#reviews-ul li");

// On DOM load, check window location for query string
document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  const product = urlParams.get("product");
  if (product) {
    reviewsSelect.firstElementChild.classList.remove("text-gray-400");
    reviewsSelect.firstElementChild.classList.add("text-black");
    reviewsSelect.firstElementChild.innerHTML = document.querySelector(
      `product-review[data-handle="${product}"] h2`
    ).innerHTML;
    const reviews = document.querySelectorAll("product-review");
    reviews.forEach((review) => {
      const title = review.dataset.handle;
      if (title.trim() === product.trim()) {
        review.style.display = "block";
      } else {
        review.style.display = "none";
      }
    });
    const visibleReviews = document.querySelectorAll(
      'product-review[style="display: block;"]'
    );
    if (visibleReviews.length === 1) {
      clearAll.style.display = "flex";
    }
  }
});

reviewsSelect.addEventListener("click", (event) => {
  reviewsUl.dataset.active = true;
});

document.addEventListener("click", (event) => {
  if (event.target !== reviewsSelect && event.target !== reviewsUl) {
    reviewsUl.dataset.active = false;
  }
});

reviewsLi.forEach((li) => {
  li.addEventListener("click", (event) => {
    const value = event.target.innerHTML;

    reviewsSelect.firstElementChild.classList.remove("text-gray-400");
    reviewsSelect.firstElementChild.classList.add("text-black");
    reviewsSelect.firstElementChild.innerHTML = value;
    reviewsSelect.blur();
    reviewsUl.dataset.active = false;
    const reviews = document.querySelectorAll("product-review");
    reviews.forEach((review) => {
      const title = review.querySelector("h2").innerHTML;
      if (title.trim() === value.trim()) {
        review.style.display = "block";
        const urlForBrowser = `${window.Shopify.routes.root}pages/reviews?product=${review.dataset.handle}`;
        window.history.pushState({}, "", urlForBrowser);
      } else {
        review.style.display = "none";
      }
    });
    const visibleReviews = document.querySelectorAll(
      'product-review[style="display: block;"]'
    );
    if (visibleReviews.length === 1) {
      clearAll.style.display = "flex";
    } else {
      clearAll.style.display = "none";
    }
  });
});

clearAll.addEventListener("click", (event) => {
  const reviews = document.querySelectorAll("product-review");
  reviews.forEach((review) => {
    review.style.display = "block";
  });
  clearAll.style.display = "none";
  reviewsSelect.firstElementChild.classList.remove("text-black");
  reviewsSelect.firstElementChild.classList.add("text-gray-400");
  reviewsSelect.firstElementChild.innerHTML = "Select a product";
  const urlForBrowser = `${window.Shopify.routes.root}pages/reviews?view=${template}`;
  window.history.pushState({}, "", urlForBrowser);
});

class ProductReview extends HTMLElement {
  static observedAttributes = ["data-modal-open"];

  constructor() {
    super();
    this.product = this.dataset.handle;
    this.dialog = null;
    this.blockquote = this.querySelector("blockquote");
    this.buttons = this.querySelectorAll("button");
    this.showModalButton = this.querySelector("[data-show-modal]");
    this.currentPage = 1;
    this.pages = this.dataset.pages;
  }

  connectedCallback() {
    this.showModalButton.addEventListener("click", () => {
      this.createModal();
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-modal-open" && newValue === "true") {
      const endOfList = document.querySelector(
        "[data-testimonials] #end-of-list"
      );
      const parentContainer = endOfList.parentNode;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.currentPage == this.pages) {
              parentContainer.removeChild(endOfList);
              observer.unobserve(endOfList);
              this.currentPage = 1;
            } else {
              this.currentPage++;
              fetch(
                `${window.Shopify.routes.root}products/${this.product}?view=testimonials&page=${this.currentPage}`
              )
                .then((response) => response.text())
                .then((html) => {
                  const doc = parser.parseFromString(html, "text/html");
                  parentContainer.insertBefore(doc.body, endOfList);
                });
            }
          }
        });
      });
      observer.observe(endOfList);
    }
  }

  async createModal() {
    await fetch(
      `${window.Shopify.routes.root}products/${this.product}?view=testimonials-dialog`
    )
      .then((response) => response.text())
      .then((html) => {
        const dialog = parser.parseFromString(html, "text/html");
        document.body.appendChild(dialog.body.firstChild);
        const modal = document.querySelector("[data-testimonials");
        modal.showModal();
        this.dataset.modalOpen = true;
        freezeBody(true);
        modal.addEventListener("close", () => {
          modal.remove();
          this.dataset.modalOpen = false;
          freezeBody(false);
        });
      });
  }
}

// customElements.define('product-reviews', ProductReviews);
customElements.define("product-review", ProductReview);
